export default __webpack_public_path__ + "static/media/kubernetes-long.0d222acc.svg";